export class MarcarPerdaContasReceberRequest {
    public idContasReceberParcela: number = 0;
}
